export const HOME = {
  emergentLink: 'home-emergent-link'
};

export const AUTH = {
  registerButton: 'auth-register-button',
  loginButton: 'auth-login-button',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  nameInput: 'auth-name-input',
  roleSelect: 'auth-role-select',
  submitButton: 'auth-submit-button',
  switchMode: 'auth-switch-mode'
};

export const DASHBOARD = {
  container: 'dashboard-container',
  statsCard: 'dashboard-stats-card',
  createProjectButton: 'dashboard-create-project-button'
};

export const PROJECT = {
  createButton: 'project-create-button',
  titleInput: 'project-title-input',
  descriptionInput: 'project-description-input',
  addressInput: 'project-address-input',
  propertyTypeSelect: 'project-property-type-select',
  projectTypeSelect: 'project-project-type-select',
  card: 'project-card'
};

export const BOOKING = {
  createButton: 'booking-create-button',
  consultantSelect: 'booking-consultant-select',
  serviceTypeSelect: 'booking-service-type-select',
  dateInput: 'booking-date-input',
  budgetInput: 'booking-budget-input',
  descriptionInput: 'booking-description-input',
  payButton: 'booking-pay-button'
};

export const INSPECTION = {
  createButton: 'inspection-create-button',
  typeSelect: 'inspection-type-select',
  findingsInput: 'inspection-findings-input',
  recommendationsInput: 'inspection-recommendations-input',
  severitySelect: 'inspection-severity-select',
  uploadButton: 'inspection-upload-button'
};

export const COMPLIANCE = {
  createButton: 'compliance-create-button',
  typeSelect: 'compliance-type-select',
  itemCheckbox: 'compliance-item-checkbox',
  notesInput: 'compliance-notes-input'
};

export const AI = {
  analyzeButton: 'ai-analyze-button',
  descriptionInput: 'ai-description-input',
  typeSelect: 'ai-type-select',
  uploadImage: 'ai-upload-image',
  result: 'ai-result'
};

export const RATING = {
  rateButton: 'rating-rate-button',
  starButton: 'rating-star-button',
  commentInput: 'rating-comment-input',
  submitButton: 'rating-submit-button'
};

export const CONSULTANT_PROFILE = {
  viewProfileButton: 'consultant-view-profile-button',
  bookButton: 'consultant-profile-book-button',
  ratingsSection: 'consultant-ratings-section',
  portfolioSection: 'consultant-portfolio-section',
  availabilitySection: 'consultant-availability-section'
};

export const PHOTO_UPLOAD = {
  fileInput: 'photo-upload-file-input',
  uploadButton: 'photo-upload-button',
  photoItem: 'photo-upload-item'
};

export const PRE_ASSESSMENT = {
  categorySelect: 'preassess-category-select',
  descriptionInput: 'preassess-description-input',
  outcomeInput: 'preassess-outcome-input',
  urgencySelect: 'preassess-urgency-select',
  addressInput: 'preassess-address-input',
  slotButton: 'preassess-slot-button',
  submitButton: 'preassess-submit-button'
};

export const ADMIN = {
  dashboardLink: 'admin-dashboard-link',
  bookingsTable: 'admin-bookings-table',
  bookingRow: 'admin-booking-row',
  advanceStageButton: 'admin-advance-stage-button',
  reportTextarea: 'admin-report-textarea',
  stageSelect: 'admin-stage-select',
  tabBookings: 'admin-tab-bookings',
  tabReviews: 'admin-tab-reviews',
  reviewsList: 'admin-reviews-list',
  reviewRow: 'admin-review-row',
  reviewApproveButton: 'admin-review-approve-button',
  reviewRejectButton: 'admin-review-reject-button',
  reviewStatusFilter: 'admin-review-status-filter'
};

export const TESTIMONIALS = {
  section: 'landing-testimonials-section',
  card: 'landing-testimonial-card'
};

export const CONSULTANT_LOCK = {
  lockScreen: 'consultant-lock-screen',
  progressItem: 'consultant-lock-progress-item',
  servicesCatalog: 'consultant-lock-services-catalog'
};

export const PAYMENTS = {
  page: 'payments-page',
  invoiceCard: 'payments-invoice-card',
  payButton: 'payments-pay-button',
  stageStep: 'payments-stage-step',
  emptyState: 'payments-empty-state',
  notice: 'payments-tax-invoice-notice'
};